import React from "react";
import { DotLegalPageHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation";
import ProcessingActivityStatisticsContent from "./ProcessingActivityStatisticsContent";

function ProcessingActivityStatistics() {
    const { translateString } = useTranslation();

    const breadCrumbs = [
        {
            name: translateString("processingActivities"),
            link: "/privacy/processingactivities",
        },
        {
            name: translateString("statistic"),
        },
    ];

    return (
        <React.Fragment>
            <DotLegalPageHeader breadCrumbs={breadCrumbs} />
            <ProcessingActivityStatisticsContent />
        </React.Fragment>
    );
}

export default ProcessingActivityStatistics;
